// extracted by mini-css-extract-plugin
module.exports = {"carousel_container":"styles-module--carousel_container--TcCDV","title":"styles-module--title--nf-e5","product":"styles-module--product--2TU6O"};